import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type ZonesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ZonesToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ZonesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ໂຊນ{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">
            ລາຍການໂຊນຄ່າສົ່ງ (VTE, NEAR, FAR).
          </p>
        </div>
        <div
          className="flex items-center gap-2"
          data-tourid="shipping-zones-toolbar"
        >
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງໂຊນ
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
